import React from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const FolderInIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M3 6.14288C3 4.48603 4.34315 3.14288 6 3.14288H9.24466C10.3505 3.14288 11.3913 3.66551 12.0518 4.55245L13.5021 6.50003H17.5C19.433 6.50003 21 8.06703 21 10V17.6429C21 19.5759 19.433 21.1429 17.5 21.1429H6.5C4.567 21.1429 3 19.5759 3 17.6429V6.14288ZM11.0085 6.50003L10.4477 5.74698C10.1647 5.36687 9.7186 5.14288 9.24466 5.14288H6C5.44772 5.14288 5 5.5906 5 6.14288V6.50003H11.0085ZM5 8.50003V17.6429C5 18.4713 5.67157 19.1429 6.5 19.1429H17.5C18.3284 19.1429 19 18.4713 19 17.6429V10C19 9.1716 18.3284 8.50003 17.5 8.50003H5ZM11.7071 11.2929C12.0976 11.6834 12.0976 12.3166 11.7071 12.7071L11.4142 13H16C16.5523 13 17 13.4477 17 14C17 14.5523 16.5523 15 16 15H11.4142L11.7071 15.2929C12.0976 15.6834 12.0976 16.3166 11.7071 16.7071C11.3166 17.0976 10.6834 17.0976 10.2929 16.7071L8.29289 14.7071C8.10536 14.5195 8 14.2652 8 14C8 13.7348 8.10536 13.4804 8.29289 13.2929L10.2929 11.2929C10.6834 10.9024 11.3166 10.9024 11.7071 11.2929Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

FolderInIcon.propTypes = {
  ...sizePropsTypes,
};

export default FolderInIcon;
